import { render, staticRenderFns } from "./OreColorButton.vue?vue&type=template&id=5a9fcd86&"
import script from "./OreColorButton.vue?vue&type=script&lang=ts&"
export * from "./OreColorButton.vue?vue&type=script&lang=ts&"
import style0 from "./OreColorButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports